import { ethers } from "ethers";
import type { StoredJoinSplitNote } from "../joinsplit/types";

/** The unspent notes of one pool, chain and token a settlement may spend. */
export function candidateNotes(
  notes: StoredJoinSplitNote[],
  pool: string,
  chainId: bigint,
  tokenAddress: string,
): StoredJoinSplitNote[] {
  const token = ethers.getAddress(tokenAddress);
  return notes.filter((stored) => {
    const note = stored.note;
    if (
      stored.spent ||
      note.protocol !== "flat-joinsplit-v2" ||
      note.schemaVersion !== 2 ||
      note.chainId !== Number(chainId) ||
      !note.poolAddress ||
      !ethers.isAddress(note.poolAddress) ||
      ethers.getAddress(note.poolAddress) !== pool ||
      note.treeIndex === undefined ||
      note.leafIndex < 0 ||
      !note.tokenData ||
      !ethers.isAddress(note.tokenData.tokenAddress) ||
      ethers.getAddress(note.tokenData.tokenAddress) !== token
    ) {
      return false;
    }
    return true;
  });
}
